import { render } from "./InvoiceDisplay2.vue?vue&type=template&id=d5ee8534&scoped=true"
import script from "./InvoiceDisplay2.vue?vue&type=script&lang=js"
export * from "./InvoiceDisplay2.vue?vue&type=script&lang=js"

import "./InvoiceDisplay2.vue?vue&type=style&index=0&id=d5ee8534&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5ee8534"]])

export default __exports__